<template>
  <div>
    <multidocument-upload-button
      :required="field.required"
      v-model="value"
      :value="value"
      :rules="validationRules"
      @uploading="$emit('toggle-confirm-button', true)"
      @uploaded="$emit('toggle-confirm-button', false)"></multidocument-upload-button>
    <span class="text-caption">
      <i18n-t keypath="customForms.messages.maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed">
        <template #size><strong>50MB</strong></template>
        <template #count>
          <strong>10</strong>
        </template>
        <template #image>
          <strong>{{ $t('global.basicTerms.image') }}</strong>
        </template>
        <template #text>
          <strong>{{ $t('global.basicTerms.text') }}</strong>
        </template>
        <template #zip>
          <strong>{{ $t('global.basicTerms.zip') }}</strong>
        </template>
        <template #spreadsheet>
          <strong>{{ $t('global.basicTerms.spreadsheet') }}</strong>
        </template>
      </i18n-t>
    </span>
  </div>
</template>

<script>
import customFieldTypeMixin from '@/modules/custom_fields/mixins/customFieldTypeMixin';

export default {
  name: 'custom-field-multidocument',
  mixins: [customFieldTypeMixin]
};
</script>
